jQuery(document).ready(function() {

    if( !document.getElementById('sliderCountdown') || !( document.getElementById('sliderCountdown').length > 0 ) )
        return

    var output = ''

    var s_days      = 'days'
    var s_day       = 'day'
    var s_left      = 'left'
    var s_hours     = 'hours'
    var s_hour      = 'hour'
    var s_minutes   = 'minutes'
    var s_minute    = 'minute'
    var s_seconds   = 'seconds'
    var s_second    = 'second'
    var s_happening = 'Happening now'


    if(lang=='fr'){
        s_days      = 'jours'
        s_days      = 'jour'
        s_left      = 'gauche'
        s_hours     = 'heures'
        s_hour      = 'heure'
        s_minutes   = 'minutes'
        s_minute    = 'minute'
        s_seconds   = 'secondes'
        s_second    = 'seconde'
        s_happening = 'En cours'

    }
    var countDownDate   = Date.parse(iw_start_date);

    var x = setInterval(function() {

        var now             = Date.parse(Date());
        var distance = countDownDate - now

        var days = Math.floor(distance / (1000 * 60 * 60 * 24));
        var hours = Math.floor((distance % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        var minutes = Math.floor((distance % (1000 * 60 * 60)) / (1000 * 60));
        var seconds = Math.floor((distance % (1000 * 60)) / 1000);

        if(days>=2){
            output = days + ' ' + s_days
        }else if(days == 1){
            output = days + ' ' + s_day
        }else if(hours > 1){
            output = hours + ' ' + s_hours
        }else if(hours == 1){
            output = hours + ' ' + s_hour
        }else if(minutes>1){
            output = minutes + ' ' + s_minutes
        }else if(minutes == 1){
            output = minutes + ' ' + s_minute
        }else if(seconds > 1){
            output = seconds + ' ' + s_seconds
        }else if( seconds == 1) {
            output = seconds + ' ' + s_second
        }
        output += ' ' + s_left;
        document.getElementById('sliderCountdown').innerHTML = output;

        if (distance < 0) {
            clearInterval(x);
            document.getElementById('sliderCountdown').innerHTML = s_happening
        }
    }, 1000);
 });
